import { SvgIconProps } from '@mui/material'
import React from 'react'

const Confirm: React.FC<SvgIconProps> = (props) => {
  return (
    <svg
      width={96}
      height={96}
      viewBox='0 0 96 96'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <circle cx={48} cy={48} r={48} fill='#FFF4ED' />
      <path
        d='M52.9141 40.9609C51.6325 40.9609 50.5898 39.9183 50.5898 38.6367V31H38.7031C36.6892 31 35.0508 32.6384 35.0508 34.6523V61.3477C35.0508 63.3616 36.6892 65 38.7031 65H57.2969C59.3108 65 60.9492 63.3616 60.9492 61.3477V40.9609H52.9141ZM40.4961 54.9062H45.3252C45.8753 54.9062 46.3212 55.3522 46.3212 55.9023C46.3212 56.4525 45.8753 56.8984 45.3252 56.8984H40.4961C39.946 56.8984 39.5 56.4525 39.5 55.9023C39.5 55.3522 39.946 54.9062 40.4961 54.9062ZM39.5 50.5898C39.5 50.0397 39.946 49.5938 40.4961 49.5938H55.1055C55.6556 49.5938 56.1016 50.0397 56.1016 50.5898C56.1016 51.14 55.6556 51.5859 55.1055 51.5859H40.4961C39.946 51.5859 39.5 51.14 39.5 50.5898ZM55.1055 44.2812C55.6556 44.2812 56.1016 44.7272 56.1016 45.2773C56.1016 45.8275 55.6556 46.2734 55.1055 46.2734H40.4961C39.946 46.2734 39.5 45.8275 39.5 45.2773C39.5 44.7272 39.946 44.2812 40.4961 44.2812H55.1055Z'
        fill='#F36F21'
      />
      <path
        d='M52.582 38.6367C52.582 38.8198 52.731 38.9687 52.9141 38.9687H60.5052C60.323 38.6323 60.0886 38.3233 59.807 38.0568L53.4039 31.9991C53.1554 31.764 52.8786 31.5679 52.5821 31.4131V38.6367H52.582Z'
        fill='#F36F21'
      />
    </svg>
  )
}

export default Confirm
